<div class="quick-deposit">
    <div class="quick-deposit__header">
        <span class="title quick-deposit__header-text">{{ quickDepositTitle }}</span>
        <span class="close quick-deposit__close" *msShowInEpcot="false" (click)="close()">
            <i class="theme-ex"></i>
        </span>
        <button class="close-btn" *msShowInEpcot="true" (click)="close()">
            {{ sitecore.globalMessages.Close }}
        </button>
    </div>
    <div class="quick-deposit__scroller betslip-vars-scope">
        @if (!isPaymentsLibraryEnabled) {
            <iframe
                class="quick-deposit__iframe"
                allow="payment"
                [bsQuickDepositAnimation]="animationConfig"
                [src]="url"
                (done)="onAnimationDone()"
                (load)="onIFrameLoad($event)">
            </iframe>
        }
        @defer (when isPaymentsLibraryEnabled) {
            <bqd-app [stake]="currentStake" />
        }
    </div>
</div>
